import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import VueTailwind from 'vue-tailwind'



import { library } from '@fortawesome/fontawesome-svg-core'
import {faHome, faClock, faCheck, faFileExport, faDesktop, faCamera, faVideo} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faClock, faCheck, faFileExport, faDesktop, faCamera, faVideo)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueTailwind)

Vue.config.productionTip = false


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
